import { jsx as _jsx } from "react/jsx-runtime";
const CrispSpacer = ({}) => {
    return _jsx("div", { style: { minHeight: '120px' } });
};
export default CrispSpacer;
